module.exports = {
  config: {
    apiKey: 'AIzaSyBfe9CrszOrcMUG612DJDnNWqBf7egOwI0',
    authDomain: 'lma-fes-prod.firebaseapp.com',
    databaseURL: 'https://lma-fes-prod.firebaseio.com',
    projectId: 'lma-fes-prod',
    storageBucket: 'lma-fes-prod.appspot.com',
    messagingSenderId: '69249157182',
    appId: '1:69249157182:web:0dc03389a636615af9696f',
    measurementId: 'G-NN5L11HDN4'
  },
  API_URL: 'https://l-ma.co.jp',
  NEW_API_URL: 'https://api.l-ma.co.jp',
  LMA_BASE_URL: 'https://l-ma.co.jp'
}
